/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Auto_Embed_On_SyncInputs */



/**
* | output |
* | --- |
* | "Auto-Embed on Sync" |
*
* @param {Spaces_Auto_Embed_On_SyncInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_auto_embed_on_sync = /** @type {((inputs?: Spaces_Auto_Embed_On_SyncInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Auto_Embed_On_SyncInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auto-Einbetten bei Synchronisierung")
	return /** @type {LocalizedString} */ ("Auto-Embed on Sync")
});